import { BaseFetch } from "../main-model"
export default class TeacherTimeModel extends BaseFetch {
  getTeacherTimeBy = (data) =>
    this.authFetch({
      url: "teacher-time/getTeacherTimeBy",
      method: "POST",
      body: JSON.stringify(data),
    })
  getTeacherTimeSubjectBy = (data) =>
    this.authFetch({
      url: "teacher-time/getTeacherTimeSubjectBy",
      method: "POST",
      body: JSON.stringify(data),
    })
  getTeacherTimeBySubClass = (data) =>
    this.authFetch({
      url: "teacher-time/getTeacherTimeBySubClass",
      method: "POST",
      body: JSON.stringify(data),
    })
  getTeacherTimeById = (data) =>
    this.authFetch({
      url: "teacher-time/getTeacherTimeById",
      method: "POST",
      body: JSON.stringify(data),
    })
    getTeacherTimeSummaryBy = (data) =>
    this.authFetch({
      url: "teacher-time/getTeacherTimeSummaryBy",
      method: "POST",
      body: JSON.stringify(data),
    })
  updateTeacherTimeById = (data) =>
    this.authFetch({
      url: "teacher-time/updateTeacherTimeById",
      method: "POST",
      body: JSON.stringify(data),
    })
  insertTeacherTime = (data) =>
    this.authFetch({
      url: "teacher-time/insertTeacherTime",
      method: "POST",
      body: JSON.stringify(data),
    })
  deleteTeacherTimeById = (data) =>
    this.authFetch({
      url: "teacher-time/deleteTeacherTimeById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
